import {Injectable} from "@angular/core";
import {AuthService} from "../../../../core/services/auth.service";
import axios from "axios";
import {DashboardData} from "../models/dashboard-data.model";

@Injectable({
  providedIn: 'root'
})

export class DashboardService {
  public async getAsync(): Promise<DashboardData> {
    return (await axios.get<DashboardData>("/system/dashboard")).data;
  }
}
